import { Client, ClientWithExtras } from './client';
import { Medication, ZipCode } from '../common';

import { BaseDataTransferObject } from '../base-data-transfer-object';
import { BillingInformation } from '../billing/billing-information';
import { Physician } from './physician';
import { ResponsibleParty } from './reponsible-party';
import { Room } from './room';
import { Unit } from './unit';

export class SexualOrientation extends BaseDataTransferObject {
  public code!: string;
  public name!: string;
}

export class GenderIdentity extends BaseDataTransferObject {
  public code!: string;
  public name!: string;
}

export class Patient extends BaseDataTransferObject {
  public code!: string;
  public unit!: Unit;
  public unitId!: number;
  public room!: Room;
  public roomId!: number;
  public firstName!: string;
  public lastName!: string;
  public middleName!: string;
  public gender!: string;
  public medicalRecordId!: string;
  public socialSecurityNumber!: string;
  public bed!: string;
  public phone!: string;
  public mobile!: string;
  public email!: string;
  public address!: string;
  public zipCodePlus4!: string;
  public sameAsClientAddress!: boolean;
  public birthDate!: string | number | Date;
  public zipCode!: ZipCode;
  public zipCodeName!: string;
  public client!: ClientWithExtras;
  public clientId!: number;
  public primaryPhysician!: Physician;
  public primaryPhysicianId!: number;
  public ethnicity!: number;
  public sexualOrientationId!: number;
  public sexualOrientation!: SexualOrientation;
  public genderIdentityId!: number;
  public genderIdentity!: GenderIdentity;
  public race!: string;
}

export class PatientEditable extends Patient {
  public dob!: Date;
  public medications!: Medication[];
  public diagnoses!: number[];
  public responsibleParties!: ResponsibleParty[];
  public insuranceInformation!: BillingInformation[];
}

export class PatientSearch extends PatientEditable {
  public code!: string;
}

export class PatientSearchWithoutCollections extends Patient {
  public code!: string;
}

export class TransientPatient extends PatientEditable {
  public recentDate!: Date;
  public shouldBeDeletedDate!: Date;
}

export class PatientClientPhysician {
  public id?: number;
  public clientId!: number;
  public physicianId?: number;
  public roomId?: number;
  public bed!: string;
}
